module.exports = __webpack_public_path__ + "static/sound/bike3.ef611c3ba.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sounds/fx/vehicles/bike3.mp3
// module id = 591
// module chunks = 1